import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useState } from "react";

export const CustomInputComponent = (props) => {
  return <TextField {...props} InputLabelProps={{ shrink: true }} />;
};

export const CustomNumberComponent = (props) => {
  return (
    <TextField
      {...props}
      onKeyDown={(event) => {
        if (event.key === ".") {
          event.preventDefault();
        }
      }}
      InputLabelProps={{ shrink: true }}
    />
  );
};

export const CustomTimeComponent = (props) => {
  return (
    <TextField
      {...props}
      onKeyDown={(event) => {
        if (event.key === ".") {
          event.preventDefault();
        }
      }}
      inputProps={{ step: 1 }}
      InputLabelProps={{ shrink: true }}
    />
  );
};

export const CustomPasswordComponent = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordField = () => {
    setShowPassword(!showPassword);
  };
  return (
    <TextField
      {...props}
      type={showPassword ? "text" : "password"}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={togglePasswordField} edge="end">
              {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export const FormControlSelect = (props) => {
  const { children, selectsx, notched, ...rest } = props;
  return (
    <FormControl
      sx={{ opacity: rest.disabled ? 0.6 : 1, ...props.selectsx }}
      size={props.size}
    >
      {props.label && notched && (
        <InputLabel shrink={!!notched}>{props.label}</InputLabel>
      )}
      <Select
        {...rest}
        value={rest.value ? rest.value : null}
        notched={!!notched}
        sx={{
          "& .MuiSelect-select .notranslate::after": props.placeholder
            ? {
                content: `"${props.placeholder}"`,
                opacity: 0.42,
              }
            : {},
        }}
      >
        {children}
      </Select>
    </FormControl>
  );
};

export const FormControlMultiSelect = (props) => {
  const { children, selectsx, notched, options, value, onChange, ...rest } =
    props;

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    // Normalize and remove duplicates while preserving order.
    const seen = new Map();
    (value || []).forEach((item) => {
      // key: object id if present, otherwise stringified primitive or JSON
      const key =
        item && typeof item === "object"
          ? item.id ?? JSON.stringify(item)
          : String(item);
      if (!seen.has(key)) seen.set(key, item);
    });
    const deduped = Array.from(seen.values());
    props.formik.setFieldValue(props?.name, deduped);
  };

  return (
    <FormControl
      sx={{ opacity: rest.disabled ? 0.6 : 1, ...props.selectsx }}
      size={props.size}
    >
      {props.label && notched && (
        <InputLabel shrink={!!notched}>{props.label}</InputLabel>
      )}
      <Select
        {...rest}
        notched={!!notched}
        multiple
        onChange={handleChange}
        sx={{
          "& .MuiSelect-select .notranslate::after": props.placeholder
            ? {
                content: `"${props.placeholder}"`,
                opacity: 0.42,
              }
            : {},
        }}
        value={value || []}
        renderValue={(selected) => {
          if (!selected || selected.length === 0) return "";
          const labels = (selected || [])
            .map((sel) => {
              if (!sel) return "";
              if (typeof sel === "object")
                return sel.name ?? sel.label ?? sel.title ?? "";
              // sel is primitive (id or string) - try to find in options
              const found = (options || []).find(
                (o) => o?.id === sel || o === sel
              );
              if (found) return found.name ?? found.label ?? "";
              return String(sel);
            })
            .filter(Boolean);
          return labels.join(", ");
        }}
      >
        {options.map((variant, index) => (
          <MenuItem
            sx={{
              "&:hover": {
                backgroundColor: "#E4EAFC",
                color: "#0001FC",
                ".MuiCheckbox-root": {
                  color: "#0001FC",
                },
              },
            }}
            value={variant}
            disabled={variant.disabled}
            key={index}
          >
            <ListItemText primary={variant?.name} />
            <Checkbox
              checked={
                (value || []).findIndex((item) => item?.id === variant?.id) >= 0
              }
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
